import  React from "react";
import { useState } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import {HotKeyMappingContext} from "~common/components/app-view/index";
import {keyMap} from '~common/components/app-view/key-mapping';
import { each } from 'lodash'
import DefinitionSectionViewer from '~forms/components/definition-section-view-fc';

var Mousetrap = require("mousetrap");
var mousetrap = new Mousetrap();

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        width: "100%",
      }
    })
  );

export const ExternalDefinitionSectionWindow: React.FC<any> = ({
	
}) => {

    const classes = useStyles();  

    mousetrap.reset();

    each(keyMap, (entry: any, combo: any) => {
        mousetrap.bind(combo, function() {
        setCurrentKeyMap(entry);
        });
    });

    const [currentKeyMap, setCurrentKeyMap] = useState(null);

    return (
        <div className={classes.container}>
            <DefinitionDataProvider>
                <HotKeyMappingContext.Provider value={[currentKeyMap, setCurrentKeyMap]}>
                    <DefinitionSectionViewer/>
                </HotKeyMappingContext.Provider>
            </DefinitionDataProvider>
           
      </div>
    )
}